// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyBDHks9CaK2VuBcULrKyWJgSc9eZuHyOdo",
	authDomain: "fradol-apartmani.firebaseapp.com",
	projectId: "fradol-apartmani",
	storageBucket: "fradol-apartmani.firebasestorage.app",
	messagingSenderId: "462259389311",
	appId: "1:462259389311:web:5c7744b8f1898e5a57104a",
	measurementId: "G-JW1K3LEW9N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };

